// Builds an SSR's heater list for display.
//
// This used to be written as `elementsOptions.filter(el => Heaters.includes(...))`,
// which iterates the *catalogue* and so can only ever yield one entry per
// distinct part number. An SSR is filled to a current budget rather than a
// heater count — four 5A heaters on a 20A SSR — so repeats are legitimate and
// that form silently discarded the quantity.
//
// Iterating the heater list instead preserves both the count and the order the
// device reports.
export const buildSpecsFromHeaters = (heaters, elementsOptions) =>
  (Array.isArray(heaters) ? heaters : [])
    .filter((partNumber) => partNumber)
    .map(
      (partNumber) =>
        (Array.isArray(elementsOptions) ? elementsOptions : []).find(
          (element) => element?.partNumber === partNumber,
        ) ??
        // Not in the catalogue. Keep the row anyway: dropping it would
        // understate how many heaters the SSR carries.
        { partNumber },
    );
